import React, {useEffect, useRef, useState} from "react";
import {Col, Row, Button} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import Pagination from "../../components/common/Pagination";
import TableTopBar from "../../components/tables/top/TableTopBar";
import Swal from "sweetalert2";
import {getTrfATListAll} from "../../api/apiClient";
import Moment from "moment";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import usePdf from "../../hook/usePdf";

const TableAT = ({
                   currentPage,
                   setCurrentPage,
                   listPageSize,
                   setListPageSize,
                   total,
                   tableList,
                   setIsSearch,
                   searchParam,
                   setSearchParam,
                   updateList,
                   setTableList,
                   setTotal
                 }) => {

  const onClick = (elem) => {
    let cn = elem.target.dataset.cn;
    if (cn !== null && cn !== undefined) {
      Swal.fire({
        input: 'textarea',
        inputLabel: '[메시지 상세] 전체 내용을 확인합니다.',
        inputValue: cn,
      })
    }
  };

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setIsSearch(true);
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "이상트래픽_.xls")
  }


  const getAllList = () => {
    setIsExport(true);
    getTrfATListAll(
        searchParam.searchFcltyNo,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        Moment(searchParam.endDate).format('YYYY-MM-DD'))
        .then((res) => {
              console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);
      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        exportPdf(tableRef, '이상트래픽.pdf')
      }
      setIsExport(false);
      updateList();
    });
  };

  return (
      <>
        <Row>
          <Col md={6} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: null,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '이상트래픽',
                  }),
                }}
                // propDelete = {{
                //     isEnable: false,
                //     delFunc: null,
                // }}
                // propReg = {{
                //     isEnable: false,
                //     regFunc: null,
                // }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center report w-100"} ref={tableRef} data-name={"이상트래픽"}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  <th className={"col"}>수신시간</th>
                  <th className={"col"}>트래픽 유형</th>
                  <th className={"col"}>시설명</th>
                  <th className={"col"}>층정보</th>
                  <th className={"col"}>장치위치</th>
                  <th className={"col"}>장치ID</th>
                  <th className={"col"}>장치유형</th>
                  <th className={"col"}>메시지유형</th>
                  <th className={"col"}>메시지상세</th>
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "text-black" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        let cn_tmp = '' + elem.cn;
                        if (cn_tmp.length > 10) {
                          cn_tmp = cn_tmp.substring(0, 50) + '...';
                        } else {
                          cn_tmp = elem.cn;
                        }
                        return <tr key={idx}>
                          <td>{elem.mesure_dt_str}</td>
                          <td>{elem.abnrml_ty_nm}</td>
                          <td>{elem.fclty_nm}</td>
                          <td>{elem.fclty_dtl_nm}</td>
                          <td>{elem.device_lc_nm}</td>
                          <td>{elem.device_id}</td>
                          <td>{elem.device_ty_nm}</td>
                          <td>{elem.topic_nm}</td>
                          <td data-cn={elem.cn}
                              onClick={(elem) => {
                                onClick(elem);
                              }}
                          >
                            {cn_tmp}
                          </td>
                        </tr>;
                      })) :
                      ('')
                }
                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={""}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
                propSetIsSearch={setIsSearch}
                propSearchParam={searchParam}
                propSetSearchParam={setSearchParam}
            />
          </Col>
        </Row>
      </>
  );
};


export default TableAT;
